// Badge Animation - Alternate Between Two Texts
class BadgeAnimation extends HTMLElement {
  constructor() {
    super();
    this.toggleState = false;
    this.interval = null;
  }

  connectedCallback() {
    this.badge = this;

    this.badge1 = this.getAttribute('data-badge1') || '';
    this.badge2 = this.getAttribute('data-badge2') || '';

    // Nothing to alternate to
    if (!this.badge2) return;

    // Initial text
    this.badge.textContent = this.badge1;

    // Start animation loop
    this.interval = setInterval(() => this.updateText(), 1500);
  }

  updateText() {
    // Fade out
    this.badge.classList.add('badge-fade-out');

    // Swap text after the fade transition, then fade back in
    setTimeout(() => {
      this.badge.textContent = this.toggleState ? this.badge1 : this.badge2;
      this.badge.classList.remove('badge-fade-out');
      this.toggleState = !this.toggleState;
    }, 200); // match CSS transition duration
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }
}

customElements.define('badge-animation', BadgeAnimation);
